// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider } from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyArFH0zgZ235mYB2yMXu9620ESCX5PkSaI",
  authDomain: "genaitok.firebaseapp.com",
  projectId: "genaitok",
  storageBucket: "genaitok.appspot.com",
  messagingSenderId: "106025293070",
  appId: "1:106025293070:web:57615c65b4c8999a9a335f",
  measurementId: "G-CM0VESKDDB"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const provider = new GoogleAuthProvider();

export { auth, provider };